import { useState, useEffect, useRef } from "react";
import "./App.css";
import Navbar from "./Navbar";
import About from "./About";
import Projects from "./Projects";
import GitHub from "./GitHub";
import Services from "./Services";
import Experience from "./Experience";
import Contact from "./Contact";
import Footer from "./Footer";

const NAV_LINKS = ["About", "Projects", "GitHub", "Services", "Experience", "Contact"];

export default function App() {
  const [active, setActive] = useState("About");
  const [typed, setTyped] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const refs = useRef({});
  const fullText = "IT Specialist · System Admin · Software Engineer";

  useEffect(() => {
    let i = 0;
    const iv = setInterval(() => { setTyped(fullText.slice(0, i)); i++; if (i > fullText.length) clearInterval(iv); }, 50);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      NAV_LINKS.forEach(id => {
        const el = refs.current[id];
        if (!el) return;
        const r = el.getBoundingClientRect();
        if (r.top <= 80 && r.bottom > 80) setActive(id);
      });
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = id => {
    refs.current[id]?.scrollIntoView({ behavior: "smooth" });
    setActive(id);
    setMenuOpen(false);
  };

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ background: "#0f0f0f", color: "#e0e0e0", fontFamily: 'Inter, sans-serif' }}>
      <Navbar active={active} menuOpen={menuOpen} setMenuOpen={setMenuOpen} goTo={goTo} />
      <div className="max-w-6xl mx-auto px-6 pt-14">
        <About refs={refs} goTo={goTo} typed={typed} />
        <Projects refs={refs} />
        <GitHub refs={refs} />
        <Services refs={refs} />
        <Experience refs={refs} />
        <Contact refs={refs} />
      </div>
      <Footer />
    </div>
  );
}